import { render } from "./binahData.vue?vue&type=template&id=d5491f12&scoped=true"
import script from "./binahData.vue?vue&type=script&lang=js"
export * from "./binahData.vue?vue&type=script&lang=js"

import "./binahData.vue?vue&type=style&index=0&id=d5491f12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5491f12"]])

export default __exports__